export default __webpack_public_path__ + "static/media/eye-close-up.6a572877.svg";